module.exports = __webpack_public_path__ + "img/code.27c13e50.png";